/**
 * PEDIATRIC Pathology Configuration
 *
 * This file contains the complete configuration for the Pediatric pathology.
 * Note: Some components are not yet implemented (marked as null).
 */

import { pediatricGlossaryData } from "../glossaryData";

export const PEDIATRIC_ID = 5;

export const pediatricConfig = {
  id: PEDIATRIC_ID,
  name: "PEDIATRIC",
  displayNameKey: "pediatric", // i18n translation key

  // Feature flags - determines what features are available for this pathology
  // Available features: surveys, ecg, nutrition, howIFeel, modalities, healthBackground, medicalInformation, configParameters
  // Only include features that are enabled (presence = enabled, absence = disabled)
  features: ['howIFeel', 'customizeFrequency', 'glossary'],

  components: {
    medicalInfoForm: "ModifyMedicalInformationICC",
  },

  dashboard: {
    glossaryData: pediatricGlossaryData,
    breadcrumbTitle: "talbe_board",
    columnSet: "pediatric", // PEDIATRIC uses ICC-style columns
    exportFields: [
      "fullname",
      "antiquity",
      "weekly_adherence",
      "last_data_loaded",
      "hr_today",
      "respiratory_rate_today",
      "oxygen_saturation_today",
    ],
    exportTransformer: (row, t) => [
      row.fullname,
      row.antiquity,
      row.weekly_adherence,
      row.last_data_loaded ? row.last_data_loaded : "--",
      row.hr_today ? t("yes") : t("no"),
      row.bp_weekly_average.value,
      row.respiratory_rate_today ? t("yes") : t("no"),
      row.oxygen_saturation_today ? t("yes") : t("no")
    ],
    // Chart configurations - Pediatric uses same charts as ICC
    charts: [
      'how-i-feel',
      'heart-rate',
      'oxygen-saturation',
      'respiratory-frequency',
    ],
  },

  profileFields: {
    weight: true,
    height: true,
    bmi: true,
    bloodPressure: true,
    heartRate: true,
    ejectionFraction: false,
  },

  alerts: {
    showHowIFeelColumn: false,
    priorityLevels: [1, 2, 3],
  },
};

export default pediatricConfig;
